"use client";

import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { useFormContext } from "../__chunks/F53GGRQB.js";
import { useButton } from "../__chunks/X5NMLKT6.js";
import { useCollectionItem } from "../__chunks/RZ4GPYOB.js";
import "../__chunks/KUU7WJ55.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LVA2YJMS.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef } from "../__chunks/LMDWO4NN.js";
import { useEvent } from "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import { __objRest, __spreadProps, __spreadValues } from "../__chunks/3YLGPPWQ.js";

// src/form/form-push.tsx
import { invariant } from "@ariakit/core/utils/misc";
import { useCallback, useEffect, useState } from "react";
var TagName = "button";
function getFirstFieldsByName(items, name) {
  if (!items) return [];
  var fields = [];
  var _iterator = _createForOfIteratorHelper(items),
    _step;
  try {
    var _loop = function _loop() {
        var item = _step.value;
        if (item.type !== "field") return 0; // continue
        if (!item.name.startsWith(name)) return 0; // continue
        var nameWithIndex = item.name.replace(/(\.\d+)\..+$/, "$1");
        var regex = new RegExp("^".concat(nameWithIndex));
        if (!fields.some(function (i) {
          return regex.test(i.name);
        })) {
          fields.push(item);
        }
      },
      _ret;
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _ret = _loop();
      if (_ret === 0) continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return fields;
}
var useFormPush = createHook(function useFormPush2(_a) {
  var _b = _a,
    store = _b.store,
    value = _b.value,
    nameProp = _b.name,
    getItemProp = _b.getItem,
    _b$autoFocusOnClick = _b.autoFocusOnClick,
    autoFocusOnClick = _b$autoFocusOnClick === void 0 ? true : _b$autoFocusOnClick,
    props = __objRest(_b, ["store", "value", "name", "getItem", "autoFocusOnClick"]);
  var context = useFormContext();
  store = store || context;
  invariant(store, process.env.NODE_ENV !== "production" && "FormPush must be wrapped in a Form component.");
  var name = "".concat(nameProp);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldFocus = _useState2[0],
    setShouldFocus = _useState2[1];
  useEffect(function () {
    var _a2;
    if (!shouldFocus) return;
    var items = getFirstFieldsByName(store == null ? void 0 : store.getState().items, name);
    var element = (_a2 = items == null ? void 0 : items[items.length - 1]) == null ? void 0 : _a2.element;
    if (!element) return;
    element.focus();
    setShouldFocus(false);
  }, [store, shouldFocus, name]);
  var getItem = useCallback(function (item) {
    var nextItem = __spreadProps(__spreadValues({}, item), {
      type: "button",
      name: name
    });
    if (getItemProp) {
      return getItemProp(nextItem);
    }
    return nextItem;
  }, [name, getItemProp]);
  var onClickProp = props.onClick;
  var onClick = useEvent(function (event) {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    store == null ? void 0 : store.pushValue(name, value);
    if (!autoFocusOnClick) return;
    setShouldFocus(true);
  });
  props = __spreadProps(__spreadValues({}, props), {
    onClick: onClick
  });
  props = useButton(props);
  props = useCollectionItem(__spreadProps(__spreadValues({
    store: store
  }, props), {
    getItem: getItem
  }));
  return props;
});
var FormPush = forwardRef(function FormPush2(props) {
  var htmlProps = useFormPush(props);
  return createElement(TagName, htmlProps);
});
export { FormPush, useFormPush };